module.exports = __webpack_public_path__ + "img/no_secret.333a3e90.svg";